import styled from "styled-components";

export const BackBtn = styled.button`
  appearance: none;
  flex: 0 0 auto;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  align-self: flex-start;
  color: #181818;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  border: none;
  background: none;
  padding: 0;
`;

export const PageHeader = styled.div.attrs({
  "data-testid": "content-header",
} as Record<string, string>)`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
`;

export const HeaderActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;

  @media (max-width: 1080px) {
    align-items: flex-start;
    flex-wrap: wrap;
  }
`;

export const DownloadControls = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #181818;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
`;

export const DownloadOptions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 3px;
`;

export const DownloadLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: #181818;
  text-decoration: none;

  & svg {
    display: block;
  }
`;

export const Search = styled.form`
  position: relative;
  display: flex;
  width: min(360px, 30vw);
  min-width: 220px;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 46px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #ffffff;
  color: #181818;
  font-size: 14px;
  line-height: 20px;
  padding: 0 48px 0 16px;
  outline: none;

  &::placeholder {
    color: #7c7f7e;
  }

  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled.i`
  color: #7c7f7e;
  font-size: 14px;
  pointer-events: none;
`;

export const SearchButton = styled.button`
  appearance: none;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
`;

export const DetailLayout = styled.div.attrs({
  "data-testid": "content-detail-layout",
} as Record<string, string>)<{ $singleColumn?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $singleColumn }) =>
    $singleColumn ? "minmax(0, 1fr)" : "220px minmax(0, 1fr)"};
  gap: ${({ $singleColumn }) => ($singleColumn ? "0" : "48px")};
  min-height: 0;
  flex: 1 1 auto;
  overflow: visible;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

export const EntityContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
  min-width: 0;
`;

export const Entity = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
`;

export const EntityHeader = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  position: relative;
`;

export const EntityTitle = styled.h2`
  color: #181818;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
`;

export const SectionDownload = styled.button`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #d7ebff;
  border-radius: 50%;
  background: #ffffff;
  color: #005fb8;
  cursor: pointer;

  &:hover {
    background: #ebf4ff;
  }
`;

export const SectionDownloadMenu = styled.div`
  position: absolute;
  top: 38px;
  left: 132px;
  z-index: 4;
  display: flex;
  flex-direction: column;
  width: 164px;
  padding: 6px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(10, 45, 73, 0.16);
`;

export const SectionDownloadMenuItem = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  color: #181818;
  font-size: 14px;
  line-height: 20px;
  text-decoration: none;

  &:hover {
    background: #f8fbff;
    color: #065fa6;
  }

  & i {
    font-size: 14px;
  }
`;

export const DetailRows = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  gap: 24px;
  border-bottom: 1px solid #e7e7e7;
  padding: 12px 0;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    gap: 4px;
  }
`;

export const Description = styled.p`
  color: #181818;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const Value = styled.p`
  color: #181818;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  overflow-wrap: anywhere;
`;

export const Notes = styled.p`
  border: 1px solid #e7e7e7;
  border-radius: 6px;
  background: #f8f8f8;
  color: #181818;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  padding: 14px 16px;
  white-space: pre-wrap;
`;
